export default __webpack_public_path__ + "c770fe131654230fdd94e80bc29a0d03.svg";